var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 34,
    viewBox: "0 0 104 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4531 12.136C20.07 9.9006 16.8161 8.52284 13.227 8.52284C5.92205 8.5203 0 14.2242 0 21.2601C0 28.2961 5.92205 34 13.227 34C16.8161 34 20.07 32.6222 22.4531 30.3869V33.5788H26.4566V0H22.4531V12.136ZM13.227 30.0621C8.18108 30.0621 4.09054 26.1216 4.09054 21.2627C4.09054 16.4037 8.18108 12.4633 13.227 12.4633C18.2728 12.4633 22.3634 16.4037 22.3634 21.2627C22.3634 26.1216 18.2728 30.0621 13.227 30.0621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1614 8.88062H76.158V33.5763H80.1614V8.88062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.003 8.88062H99.9993V33.5763H104.003V8.88062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1614 0H76.158V3.97597H80.1614V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.003 0H99.9993V3.97597H104.003V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6595 12.1361C49.2765 9.90071 46.0225 8.52295 42.4334 8.52295C35.1285 8.52295 29.2064 14.2268 29.2064 21.2628C29.2064 28.2988 35.1285 34.0026 42.4334 34.0026C46.0225 34.0026 49.2765 32.6249 51.6595 30.3895V33.5815H55.663V8.88071H51.6595V12.1361ZM42.4334 30.0622C37.3875 30.0622 33.297 26.1218 33.297 21.2628C33.297 16.4038 37.3875 12.4634 42.4334 12.4634C47.4793 12.4634 51.5698 16.4038 51.5698 21.2628C51.5698 26.1218 47.4793 30.0622 42.4334 30.0622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1231 4.10799V0.114258C68.0297 0.796795 63.8626 4.27038 62.3478 8.88068H58.281V12.7298H61.9968V33.5789H66.0003V12.7298H73.3896V8.88068H66.7445C67.969 6.46008 70.3125 4.66112 73.1257 4.10799H73.1231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9259 0H85.8222V8.8806H82.8876V12.7297H85.8222V22.2015C86.2814 28.253 91.1294 33.1297 97.3153 33.8934V29.9073C93.4253 29.2045 90.4036 26.1267 89.9391 22.2979C89.9391 22.2852 89.9259 22.1279 89.9259 22.1279V12.7297H97.3153V8.8806H89.9259V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ae5711cbc7c6e827b2c9d6f63035797a.svg";
export { ForwardRef as ReactComponent };